import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { PlantpredictorComponent } from './plantpredictor/plantpredictor.component';
import { GetanswersComponent } from './getanswers/getanswers.component';
import { AskquestionsComponent } from './askquestions/askquestions.component';
import { UserdashComponent } from './userdash/userdash.component';
import { QuestionhomeComponent } from './questionhome/questionhome.component';


const routes: Routes = [
  {path: 'home', component: HomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'plantpredict', component: PlantpredictorComponent},
  {path: 'getanswers/:id', component: GetanswersComponent},
  {path: 'askquestions', component: AskquestionsComponent},
  {path: 'register', component: RegisterComponent},
  {path: 'userdash', component: UserdashComponent},
  {path: 'question', component: QuestionhomeComponent},
  {path: '', redirectTo: 'home', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
